/* Wades Books — Apple-style interactions (nav, search, menu, shelves, quick add, reveals) */
(function () {
  'use strict';
  var html = document.documentElement;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll state + tab bar auto-hide ---------- */
  var lastY = window.scrollY, ticking = false;
  function onScroll() {
    var y = window.scrollY;
    html.classList.toggle('a-scrolled', y > 4);
    if (Math.abs(y - lastY) > 6) {
      html.classList.toggle('a-tab-hide', y > lastY && y > 120);
      lastY = y;
    }
    heroProgress();
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
  }, { passive: true });

  /* ---------- Hero wall: flattens as you scroll ---------- */
  var wall = $('.a-wall');
  function heroProgress() {
    if (!wall || reduce) return;
    var r = wall.getBoundingClientRect();
    var vh = window.innerHeight;
    var p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height * 0.4) - 0.25) * 1.6);
    wall.style.setProperty('--p', p.toFixed(3));
  }

  /* ---------- Desktop flyouts ---------- */
  var nav = $('[data-a-nav]');
  var fly = $('[data-a-flyout]');
  var flyTimer = null, currentPanel = null;
  function openFly(key, trigger) {
    if (!fly) return;
    clearTimeout(flyTimer);
    var panel = $('[data-a-panel="' + key + '"]', fly);
    if (!panel) { closeFly(); return; }
    $$('.a-fly__panel', fly).forEach(function (p) { p.classList.toggle('is-on', p === panel); });
    $$('.a-nav__link').forEach(function (l) { l.classList.toggle('is-hover', l === trigger); });
    fly.style.height = panel.offsetHeight + 'px';
    fly.setAttribute('aria-hidden', 'false');
    html.classList.add('a-fly-open');
    currentPanel = panel;
  }
  function closeFly() {
    if (!fly) return;
    fly.style.height = '0px';
    fly.setAttribute('aria-hidden', 'true');
    $$('.a-fly__panel', fly).forEach(function (p) { p.classList.remove('is-on'); });
    $$('.a-nav__link').forEach(function (l) { l.classList.remove('is-hover'); });
    html.classList.remove('a-fly-open');
    currentPanel = null;
  }
  if (nav && fly && window.matchMedia('(hover: hover)').matches) {
    $$('.a-nav__link').forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        var key = link.getAttribute('data-a-fly');
        clearTimeout(flyTimer);
        if (key) {
          flyTimer = setTimeout(function () { openFly(key, link); }, currentPanel ? 0 : 120);
        } else {
          flyTimer = setTimeout(closeFly, 80);
        }
      });
      link.addEventListener('focus', function () {
        var key = link.getAttribute('data-a-fly');
        if (key) openFly(key, link); else closeFly();
      });
    });
    nav.addEventListener('mouseleave', function () { clearTimeout(flyTimer); flyTimer = setTimeout(closeFly, 160); });
    nav.addEventListener('mouseenter', function () { clearTimeout(flyTimer); });
    $$('.a-nav__logo, .a-nav__right').forEach(function (el) {
      el.addEventListener('mouseenter', function () { clearTimeout(flyTimer); flyTimer = setTimeout(closeFly, 80); });
    });
  }

  /* ---------- Search ---------- */
  var searchInput = $('[data-a-search-input]');
  var results = $('[data-a-search-results]');
  var defaultResults = results ? results.innerHTML : '';
  function openSearch() {
    closeFly(); closeMenu();
    html.classList.add('a-search-open');
    var s = $('[data-a-search]'); if (s) s.setAttribute('aria-hidden', 'false');
    setTimeout(function () { searchInput && searchInput.focus(); }, 60);
  }
  function closeSearch() {
    html.classList.remove('a-search-open');
    var s = $('[data-a-search]'); if (s) s.setAttribute('aria-hidden', 'true');
  }
  $$('[data-a-search-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openSearch(); }); });
  $$('[data-a-search-close]').forEach(function (b) { b.addEventListener('click', closeSearch); });

  var searchTimer = null, searchCtrl = null;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(n); }
    catch (e) { return '$' + n.toFixed(2); }
  }
  if (searchInput && results) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) { results.innerHTML = defaultResults; return; }
      searchTimer = setTimeout(function () {
        if (searchCtrl) searchCtrl.abort();
        searchCtrl = window.AbortController ? new AbortController() : null;
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, searchCtrl ? { signal: searchCtrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = (data && data.resources && data.resources.results) || {};
            var prods = res.products || [], colls = res.collections || [];
            var out = '';
            if (colls.length) {
              out += '<p class="a-fly__label">Categories</p><ul class="a-search__colls" role="list">' +
                colls.slice(0, 5).map(function (c) { return '<li><a href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>'; }).join('') + '</ul>';
            }
            out += '<p class="a-fly__label">' + (prods.length ? 'Products' : 'No products found') + '</p>';
            out += prods.map(function (p) {
              var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '';
              return '<a class="a-search__hit" href="' + esc(p.url) + '">' + img + '<span><span class="a-search__hit-t">' + esc(p.title) +
                '</span><span class="a-search__hit-p">' + money(p.price) + '</span></span></a>';
            }).join('');
            out += '<a class="a-search__all" href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">See all results for “' + esc(q) + '” ›</a>';
            results.innerHTML = out;
          })
          .catch(function () {});
      }, 180);
    });
  }

  /* ---------- Mobile menu ---------- */
  var menu = $('[data-a-menu]');
  function openMenu() {
    if (!menu) return;
    closeSearch();
    html.classList.add('a-menu-open');
    menu.setAttribute('aria-hidden', 'false');
    $$('[data-a-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeMenu() {
    if (!menu) return;
    html.classList.remove('a-menu-open');
    menu.setAttribute('aria-hidden', 'true');
    $$('[data-a-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(resetMenu, 320);
  }
  function resetMenu() {
    if (!menu) return;
    var root = $('.a-menu__pane--root', menu);
    root && root.classList.remove('is-out');
    $$('.a-menu__pane--sub', menu).forEach(function (p) { p.classList.remove('is-in'); p.hidden = true; });
  }
  $$('[data-a-menu-open]').forEach(function (b) {
    b.addEventListener('click', function () { html.classList.contains('a-menu-open') ? closeMenu() : openMenu(); });
  });
  $$('[data-a-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });
  if (menu) {
    $$('[data-a-sub]', menu).forEach(function (b) {
      b.addEventListener('click', function () {
        var pane = $('[data-a-subpane="' + b.getAttribute('data-a-sub') + '"]', menu);
        if (!pane) return;
        pane.hidden = false;
        $('.a-menu__pane--root', menu).classList.add('is-out');
        requestAnimationFrame(function () { requestAnimationFrame(function () { pane.classList.add('is-in'); }); });
      });
    });
    $$('[data-a-back]', menu).forEach(function (b) {
      b.addEventListener('click', function () {
        var pane = b.closest('.a-menu__pane--sub');
        pane.classList.remove('is-in');
        $('.a-menu__pane--root', menu).classList.remove('is-out');
        setTimeout(function () { pane.hidden = true; }, 380);
      });
    });
  }

  var scrim = $('[data-a-scrim]');
  if (scrim) scrim.addEventListener('click', function () { closeFly(); closeSearch(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeFly(); closeSearch(); closeMenu(); }
    if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) { e.preventDefault(); openSearch(); }
  });

  /* ---------- Cart: open the theme's drawer, keep the count in sync ---------- */
  function drawer() { var d = document.querySelector('cart-drawer'); return d && typeof d.open === 'function' ? d : null; }
  $$('[data-a-cart]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var d = drawer();
      if (d && !document.body.classList.contains('page-cart')) { e.preventDefault(); d.open(a); }
    });
  });
  var countEls = $$('[data-a-count]');
  function setCount(n) {
    countEls.forEach(function (el) {
      var old = parseInt(el.textContent, 10) || 0;
      el.textContent = n;
      el.classList.toggle('is-empty', !n);
      if (n > old) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }
  var countTimer = null;
  function refreshCount() {
    clearTimeout(countTimer);
    countTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count || 0); })
        .catch(function () {});
    }, 120);
  }
  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble && window.MutationObserver) {
    new MutationObserver(refreshCount).observe(bubble, { childList: true, subtree: true, characterData: true });
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCount(); });

  /* ---------- Quick add from Apple tiles ---------- */
  var toast;
  function showToast(msg) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'a-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.innerHTML = msg;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-a-add]');
    if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    var d = drawer();
    var body = { items: [{ id: parseInt(btn.getAttribute('data-a-add'), 10), quantity: 1 }] };
    if (d) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (!res.ok) { showToast(esc(res.j.description || res.j.message || 'Could not add this item.')); return; }
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1800);
        refreshCount();
        if (d && res.j.sections && typeof d.renderContents === 'function') {
          try {
            var state = res.j.items && res.j.items[0] ? res.j.items[0] : {};
            state.sections = res.j.sections;
            d.classList.remove('is-empty');
            d.renderContents(state);
            return;
          } catch (err) { /* fall through to toast */ }
        }
        showToast('Added to cart. <a href="/cart">View cart ›</a>');
      })
      .catch(function () { btn.classList.remove('is-loading'); showToast('Something went wrong. Please try again.'); });
  });

  /* ---------- Shelves: paddles ---------- */
  $$('[data-a-shelf]').forEach(function (shelf) {
    var vp = $('.a-shelf__viewport', shelf);
    var prev = $('[data-a-prev]', shelf), next = $('[data-a-next]', shelf);
    if (!vp || !prev || !next) return;
    function update() {
      var max = vp.scrollWidth - vp.clientWidth - 2;
      prev.disabled = vp.scrollLeft <= 2;
      next.disabled = vp.scrollLeft >= max;
    }
    function step(dir) {
      var card = $('.a-card, .a-feat', vp);
      var w = card ? card.getBoundingClientRect().width + 20 : 260;
      var n = Math.max(1, Math.floor((vp.clientWidth * 0.85) / w));
      vp.scrollBy({ left: dir * n * w, behavior: reduce ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    vp.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Reveal on scroll ---------- */
  var revealEls = $$('.a-reveal, .a-stage');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }
  // Safety net: never leave content hidden.
  setTimeout(function () { $$('.a-reveal:not(.is-in)').forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); }); }, 1500);

  /* ---------- Product page: sticky glass buy bar ---------- */
  var buybox = $('.wb-pdp__buybox');
  if (buybox) {
    var title = ($('.wb-pdp__title h1') || {}).textContent || document.title;
    var priceEl = $('.wb-pdp__buybox-price .price-item--last, .wb-pdp__buybox-price .price-item--regular');
    var img = $('.wb-pdp__image img');
    var isMobile = window.matchMedia('(max-width: 749px)');
    var bar = document.createElement('div');
    bar.className = 'a-pbar';
    bar.innerHTML = '<div class="a-pbar__in a-wrap">' +
      (img ? '<img class="a-pbar__img" alt="" src="' + esc((img.currentSrc || img.src).replace(/width=\d+/, 'width=120')) + '">' : '') +
      '<span class="a-pbar__title">' + esc(title.trim()) + '</span>' +
      '<span class="a-pbar__price" data-a-pbar-price></span>' +
      '<button type="button" class="a-btn a-btn--sm" data-a-pbar-buy></button></div>';
    document.body.appendChild(bar);
    var pbPrice = $('[data-a-pbar-price]', bar), pbBuy = $('[data-a-pbar-buy]', bar);
    function syncBar() {
      var p = $('.wb-pdp__buybox-price .price__sale .price-item--sale') || priceEl;
      var priceWrap = $('.wb-pdp__buybox-price .price');
      if (priceWrap && priceWrap.classList.contains('price--on-sale')) p = $('.wb-pdp__buybox-price .price-item--sale');
      else p = $('.wb-pdp__buybox-price .price__regular .price-item--regular') || p;
      pbPrice.textContent = p ? p.textContent.trim() : '';
      var atc = $('.wb-pdp__buybox .product-form__submit');
      var sold = atc && atc.disabled;
      pbBuy.textContent = sold ? 'Sold out' : (isMobile.matches ? 'Add to Cart' : 'Buy Now');
      pbBuy.disabled = !!sold;
    }
    syncBar();
    pbBuy.addEventListener('click', function () {
      if (isMobile.matches) {
        var atc = $('.wb-pdp__buybox .product-form__submit');
        if (atc && !atc.disabled) atc.click();
      } else {
        var bn = $('.wb-pdp__buybox .wb-buy-now');
        if (bn) bn.click(); else buybox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    if (window.MutationObserver) new MutationObserver(syncBar).observe(buybox, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    if ('IntersectionObserver' in window) {
      var target = $('.wb-pdp__buybox .wb-buy-now') || $('.wb-pdp__buybox .product-form__submit') || buybox;
      new IntersectionObserver(function (en) {
        var e0 = en[0];
        bar.classList.toggle('is-on', !e0.isIntersecting && e0.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(target);
    }
    isMobile.addEventListener && isMobile.addEventListener('change', syncBar);
  }

  onScroll();
})();
